<template>
    <div>
        <input type="file"
               ref="fileInput"
               style="display: none"
               @change="changeInput"
               :accept="accepts"
               :multiple="multiple">


        <div class="t-c">
            <button type="button"
                    class="btn"
                    :class="buttonClass"
                    :disabled="disabled"
                    @click="$refs.fileInput.click()">
                <svg-icon icon="cloud-upload-alt"/>&nbsp;{{buttonTitle}}
            </button>
        </div>

        <transition-group name="progress-items" tag="div">
            <FileUploadProgress v-for="f in files"
                                :key="f._id"
                                :theme="f.theme"
                                :label="f.label"
                                :percent="f.percent"/>
        </transition-group>
    </div>
</template>

<script>
    import FileUploadProgress from '@/components/particles/FileUploadProgress'
    import {isString, isArray, makeRandomId} from "../utils/Utils";

    export default {
        name: "FileUpload",
        components: {FileUploadProgress},
        props: {
            url: {
                type: String,
                required: true,
                default: null
            },
            multiple: {
                type: [Boolean,String],
                default: false,
                validator: val => /(true|false)/.test(`${val}`.toLowerCase())
            },
            fileFormats: {
                type: [Array, String],
                required: true,
                default: () => ['text/plain'],
                validator: val => isArray(val) || isString(val)
            },
            autoUpload: {
                type: Boolean,
                default: true
            },
            disabled: {
                type: Boolean,
                default: false,
            },
            buttonTitle: {
                type: String,
                default: 'SELECIONAR'
            },
            buttonClass: {
                type: [String, Array],
                default: 'btn-theme-1',
                validator: val => {
                    return isString(val) || isArray(val)
                }
            }
        },
        data() {
            return {
                files: []
            }
        },
        methods: {
            addFile(file) {
                if(this.validateFormats(file.type)) {
                    this.files.push({
                        fileObject: file,
                        label: file.name,
                        percent: 0,
                        theme: 'theme-1',
                        _id: makeRandomId()
                    });
                }
            },
            validateFormats(format) {
                if (isString(this.fileFormats)) return format === this.fileFormats;
                return this.fileFormats.filter(ff => new RegExp('^' + ff, 'i').test(format)).length > 0
            },
            upload() {
                this.files.forEach(f => {
                    const formData = new FormData();
                    formData.append('file', f.fileObject);

                    this.$appHttp.post(this.url, formData, {
                            headers: {
                                'Content-Type': 'multipart/form-data'
                            },
                            onUploadProgress: progressEvent => this.updateProgress(f._id, progressEvent)
                        })
                        .then(({data}) => {
                            this.removeFile(f);
                            this.$emit('onFileUploaded', {file: f.fileObject, response: data});
                        })
                        .catch(({response}) => {
                            this.$emit('onFileUploadedFail', {file: f.fileObject, error: response});
                            this.$set(f, 'theme', 'red');

                            if (response.status === 422 && response.data.message) {
                                this.$set(f, 'label', response.data.message);
                            } else {
                                this.$set(f, 'label', 'Falha no Upload');
                            }

                            this.removeFile(f);
                            console.error('CustomerGroupFile upload fail.', response);
                        });
                })
            },
            updateProgress(id, progressEvent) {
                this.files.forEach(f => {
                    if (f._id === id) this.$set(f, 'percent', parseInt(Math.round((progressEvent.loaded * 100 ) / progressEvent.total)));
                });
            },
            changeInput() {
                if (this.multiple) Array.from(this.$refs.fileInput.files).forEach(this.addFile);
                else this.addFile(this.$refs.fileInput.files[0]);

                this.$refs.fileInput.value = '';

                if (this.autoUpload) this.upload();
            },
            removeFile(file) {
                setTimeout(() => {
                    this.files.deleteObject(file)
                }, 2500);
            }
        },
        computed: {
            accepts() {
                if (isString(this.fileFormats)) return this.fileFormats;

                return this.fileFormats.join(',')
            }
        }
    }
</script>

<style lang="scss" scoped>
    .progress-items-item {
        display: inline-block;
        margin-right: 10px;
    }
    .progress-items-enter-active, .progress-items-leave-active {
        transition: all 1s;
    }
    .progress-items-enter, .progress-items-leave-to{
        opacity: 0;
        transform: translateY(5px);
    }
</style>
